import NextImage from "next/legacy/image";
import styled from 'styled-components'

const ImageWrapper = styled.div`
    margin: 4rem 0;
`;
const Image = styled(NextImage)`
    border-radius: 5px;
`;
const Caption = styled.span`
    display: block;
    margin: 1rem 0;
`;

export default function ImageBlock({ block }) {
    return (
        <ImageWrapper>
            <Image
                src={block.image?.data?.attributes?.url}
                width={block.image?.data?.attributes?.width}
                height={block.image?.data?.attributes?.height}
                layout="responsive"
                alt={block.image?.data?.attributes?.alternativeText}
                style={{ borderRadius: '5px' }}
            />
            <Caption>{block.image?.data?.attributes?.caption}</Caption>
        </ImageWrapper>
    );
}
